export default __webpack_public_path__ + "static/media/Group 7414.c64bd71e.png";